import { render, staticRenderFns } from "./FamResource.vue?vue&type=template&id=66b681cf&scoped=true&"
import script from "./FamResource.vue?vue&type=script&lang=js&"
export * from "./FamResource.vue?vue&type=script&lang=js&"
import style0 from "./FamResource.vue?vue&type=style&index=0&id=66b681cf&lang=scss&scoped=true&"
import style1 from "./FamResource.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b681cf",
  null
  
)

component.options.__file = "FamResource.vue"
export default component.exports